/**
 * Shared window scroll helpers for route and catalog-tab navigation.
 *
 * Catalog shops and public galleries scroll the document (not a nested
 * AppShell pane). Callers must reset this intentionally — React Router does
 * not restore or clear window scroll on its own.
 */

/**
 * Scrolls the document to the top-left corner.
 *
 * @param behavior - Scroll animation; use `instant` for route changes and
 *   `smooth` for in-page occasion tab changes.
 */
export function scrollWindowToTop(behavior: ScrollBehavior = 'instant'): void {
  window.scrollTo({ top: 0, left: 0, behavior });
}
